import { Alert, Box } from '@pinchenterprisesnpm/friday-ui'
import { FEATURE_TOGGLE_MULTIDAY_REVAMP } from '@src/config/featureToggles'
import { ShiftPostPage } from '@src/features/shift-post-v2/pages'
import { DaysListItem } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/components/days-list-item/days-list-item'
import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import { ShiftPostStep } from '@src/features/shift-post-v2/steps/steps.types'
import {
  checkIfBusinessRequiresNextWorkingDaySelection,
  STARTING_DAY_ALERT_MESSAGE,
} from '@src/helpers/shiftHelpers'
import { SHIFT_PROGRESS, SHIFT_TYPE } from '@network/models/shift.model'
import { connect, FormikProps } from 'formik'

interface IIndividualDaysListProps {
  formik?: FormikProps<IScheduleSectionFormValues>
  sourcePage: ShiftPostPage
  sourceStep: ShiftPostStep
  isEditable?: boolean
}

export const IndividualDaysList = connect<IIndividualDaysListProps>(
  ({ formik, sourcePage, sourceStep, isEditable = true }) => {
    const { errors, values } = formik

    const isEditInProgressMultidayShift =
      Number(values?.type) === SHIFT_TYPE.MULTIDAY &&
      Number(values?.progress) === SHIFT_PROGRESS.ACTIVE &&
      FEATURE_TOGGLE_MULTIDAY_REVAMP &&
      sourcePage === ShiftPostPage.EDIT_SHIFT

    const isConfirmStep = sourceStep === ShiftPostStep.CONFIRM

    const hasNextWorkingDaySelected = values.days.some(
      day => day.starting_day && day.working,
    )

    const minDays = isConfirmStep ? 0 : 1

    const showSingleDayShifts =
      values.type === SHIFT_TYPE.SINGLEDAY &&
      sourcePage !== ShiftPostPage.EDIT_SHIFT &&
      values.single_day_shifts.length > minDays

    const showEditSingleDayShift =
      values.type === SHIFT_TYPE.SINGLEDAY &&
      sourcePage === ShiftPostPage.EDIT_SHIFT &&
      !!values.single_day_date &&
      isConfirmStep

    return (
      <Box mt="md">
        {showEditSingleDayShift && (
          <DaysListItem
            singleDayDate={values.single_day_date}
            isEditable={isEditable}
          />
        )}

        {/* Single day shifts */}
        {showSingleDayShifts && (
          <>
            {errors.single_day_shifts &&
              Array.isArray(errors.single_day_shifts) && (
                <Alert
                  message="One or more selected single day shifts have an invalid Hourly Pay Rate."
                  type="danger"
                />
              )}

            {values.single_day_shifts.map(day => (
              <DaysListItem
                key={day.id}
                day={day}
                isEditable={isEditable}
                semiDisabled={isEditInProgressMultidayShift}
              />
            ))}
          </>
        )}

        {/* Multiday shift */}
        {values.type === SHIFT_TYPE.MULTIDAY && (
          <>
            {errors.days && Array.isArray(errors.days) && (
              <Alert
                message="One or more selected days have an invalid Hourly Pay Rate."
                type="danger"
              />
            )}

            {checkIfBusinessRequiresNextWorkingDaySelection() &&
              !hasNextWorkingDaySelected &&
              !isConfirmStep && (
                <Alert message={STARTING_DAY_ALERT_MESSAGE} type="primary" />
              )}

            {values.days.length > minDays &&
              values.days.map(day => (
                <DaysListItem
                  key={day.id}
                  day={day}
                  isEditable={isEditable}
                  semiDisabled={isEditInProgressMultidayShift}
                />
              ))}
          </>
        )}
      </Box>
    )
  },
)
